import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { SITE_ROLES } from "../../constants/roles";

const slice = createSlice({
  name: "auth",
  initialState: {
    currentUser: { isLoggedIn: false },
    adminMode: false,
  },
  reducers: {
    disableAdminMode: (auth) => {
      console.log(`(redux) auth.disableAdminMode`);
      auth.adminMode = false;
      localStorage.removeItem("adminMode");
    },
    enableAdminMode: (auth) => {
      console.log(`(redux) auth.enableAdminMode`);
      if (
        auth.currentUser.isLoggedIn &&
        auth.currentUser.siteRole <= SITE_ROLES.ADMIN
      ) {
        auth.adminMode = true;
        localStorage.setItem("adminMode", auth.currentUser.username);
      }
    },
    login: (auth, action) => {
      console.log(`(redux) auth.login`);
      // console.log("action", action);

      auth.currentUser = {
        ...action.payload,
        isLoggedIn: true,
      };
    },
    logout: (auth) => {
      console.log(`(redux) auth.logout`);
      auth.currentUser = { isLoggedIn: false };
      auth.adminMode = false;
      localStorage.removeItem("token");
    },
  },
});

export default slice.reducer;

const { disableAdminMode, enableAdminMode, login, logout } = slice.actions;

// action creators

export const toggleAdminModeOn = () => (dispatch) => {
  dispatch(enableAdminMode());
};

export const toggleAdminModeOff = () => (dispatch) => {
  dispatch(disableAdminMode());
};

export const logUserIn = (data) => (dispatch) => {
  dispatch(login(data));
};

export const logUserOut = () => (dispatch) => {
  dispatch(logout());
};

// selectors

export const getCurrentUser = createSelector(
  (state) => state.auth,
  (auth) => auth.currentUser
);

export const isAdminModeOn = createSelector(
  (state) => state.auth,
  (auth) => auth.adminMode
);
